/**
 * Applies an alpha value to the provided hex value, returns the value in `rgba()` format.
 * Hex value should be in either #XXX or #XXXXXX format.
 * Alpha value should be:
 * - an integer in [0,255],
 * - a float in [0,1],
 * - or a 1 to 2 character hex value in the [0,255] range.
 */
export var hexToAlpha = function hexToAlpha(hex, alpha) {
  if (!/^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(hex)) {
    throw new Error("Invalid hex value '" + hex + "'");
  }

  // Strip the octothorpe
  var toParse = hex.lastIndexOf('#', 0) === 0 ? hex.substr(1) : hex;

  // Split to three 2 character parts, either directly or by duplicating single character segments
  var parts = toParse.length === 6 ? toParse.match(/[0-9A-F]{2}/gi) : toParse.match(/[0-9A-F]/gi).map(function (c) {
    return "" + c + c;
  });
  parts = parts.map(function (c) {
    return parseInt(c, 16);
  });
  var floatAlpha = alpha;
  if (!alpha) {
    floatAlpha = 0;
  } else if (typeof alpha === 'string') {
    // Parse the hex to an int, then convert it to a float.
    floatAlpha = (parseInt(alpha, 16) / 255.0).toFixed(2);
  } else if (alpha > 1) {
    // A number greater than 1 implies an integer value, convert it to a float.
    floatAlpha = (alpha / 255.0).toFixed(2);
  }
  parts.push(floatAlpha);
  return "rgba(" + parts.join(',') + ")";
};